import { Text, View } from "react-native";
import { Control } from "react-hook-form";
import { CreateCalendarEventForm } from "app/services/api/types/calendar/requests/CreateCalendarEventForm";
import { useHandleAppointmentForm } from "../hooks/useHandleAppointmentForm";
import { FormControlledRadioGroup } from "ui/molecules/form/FormControlledRadioGroup";
import { FormRow } from "ui/organisms/FormRow";
import { FormControlledMultiSelectDropdown } from "ui/molecules/form/FormControlledMultiSelectDropdown";
import { requiredValidation } from "ui/utils/Validators";

interface Props {
  control: Control<CreateCalendarEventForm>;
}

export const AdditionalInformation = ({ control }: Props) => {
  const { rolesOptions, areRolesLoading, additionalInformationOptions } =
    useHandleAppointmentForm();

  return (
    <>
      <Text className="text-gray-500 mb-4 text-sm">Additional Information</Text>
      <FormControlledRadioGroup
        id="transport-required"
        name="additional_info"
        label="Transport"
        control={control}
        isRequired
        secondaryLabel
        rules={{
          required: requiredValidation("Transport selection"),
        }}
        options={additionalInformationOptions}
      />
      <View className="mt-4">
        <FormRow label="Assigned role(s)">
          <FormControlledMultiSelectDropdown<CreateCalendarEventForm>
            name="role_ids"
            control={control}
            placeholder="Choose role"
            isRequired
            options={rolesOptions}
            isDisabled={areRolesLoading}
            rules={{
              required: requiredValidation("Role(s)"),
            }}
          />
        </FormRow>
      </View>
    </>
  );
};
